module.exports = __webpack_public_path__ + "static/media/train11-2.6a019d35.png";